import LegalPageLayout from '../components/LegalPageLayout';

const sections = [
  { id: 'article-1', title: 'Article 1 - Objet' },
  { id: 'article-2', title: 'Article 2 - Produits et Services' },
  { id: 'article-3', title: 'Article 3 - Commandes' },
  { id: 'article-4', title: 'Article 4 - Prix et Paiement' },
  { id: 'article-5', title: 'Article 5 - Retrait de Commande' },
  { id: 'article-6', title: 'Article 6 - Annulation/Remboursement' },
  { id: 'article-7', title: 'Article 7 - Responsabilité' },
  { id: 'article-8', title: 'Article 8 - Protection des Données' },
  { id: 'article-9', title: 'Article 9 - Service Client' },
  { id: 'article-10', title: 'Article 10 - Dispositions Générales' },
];

export default function CGV() {
  return (
    <LegalPageLayout
      title="Conditions Générales de Vente (CGV)"
      subtitle="LEMO - Plateforme de commande de restauration en click & collect"
      lastUpdate="26 décembre 2025"
      sections={sections}
    >
      <section id="article-1">
        <h2>Article 1 - Objet</h2>
        <p>
          Les présentes Conditions Générales de Vente (CGV) définissent les droits et obligations 
          des parties dans le cadre de la vente de produits alimentaires proposés par les restaurants 
          partenaires via la plateforme LEMO.
        </p>
        <p>
          Toute commande passée sur la plateforme implique l'acceptation préalable et sans réserve 
          des présentes CGV.
        </p>
      </section>

      <section id="article-2">
        <h2>Article 2 - Produits et Services</h2>
        
        <h3>2.1 - Description des produits</h3>
        <ul>
          <li>Les produits proposés sont des plats, boissons et autres articles alimentaires préparés par les restaurants partenaires</li>
          <li>Les descriptions, photos et prix sont fournis par les restaurants et sont susceptibles de varier</li>
          <li>LEMO s'efforce de garantir l'exactitude des informations mais n'est pas responsable des erreurs commises par les restaurateurs</li>
        </ul>

        <h3>2.2 - Disponibilité</h3>
        <ul>
          <li>Les produits sont proposés dans la limite des stocks disponibles</li>
          <li>En cas d'indisponibilité d'un produit après commande, le client sera informé et pourra demander un remboursement ou un remplacement</li>
          <li>Les restaurants peuvent modifier leur menu à tout moment</li>
        </ul>

        <h3>2.3 - Allergènes et informations nutritionnelles</h3>
        <ul>
          <li>Les informations relatives aux allergènes sont fournies par les restaurants</li>
          <li>En cas de doute, le client doit contacter directement le restaurant</li>
          <li>LEMO décline toute responsabilité en cas d'erreur dans les informations nutritionnelles fournies par les restaurants</li>
        </ul>
      </section>

      <section id="article-3">
        <h2>Article 3 - Commandes</h2>
        
        <h3>3.1 - Processus de commande</h3>
        <ul>
          <li>Le client sélectionne les produits souhaités et les ajoute à son panier</li>
          <li>Le client vérifie sa commande avant validation</li>
          <li>Le client procède au paiement en ligne</li>
          <li>La commande est confirmée par email et notification push</li>
        </ul>

        <h3>3.2 - Confirmation de commande</h3>
        <ul>
          <li>Une confirmation de commande est envoyée par email à l'adresse fournie lors de l'inscription</li>
          <li>Cette confirmation contient le récapitulatif de la commande, le numéro de commande et l'heure de retrait estimée</li>
          <li>Le client doit vérifier l'exactitude des informations et signaler toute erreur dans les plus brefs délais</li>
        </ul>

        <h3>3.3 - Modification de commande</h3>
        <ul>
          <li>Toute demande de modification doit être effectuée dans les <strong>5 minutes</strong> suivant la validation</li>
          <li>Au-delà de ce délai, la commande ne peut plus être modifiée</li>
          <li>Les modifications sont soumises à la disponibilité des produits</li>
        </ul>
      </section>

      <section id="article-4">
        <h2>Article 4 - Prix et Paiement</h2>
        
        <h3>4.1 - Prix</h3>
        <ul>
          <li>Les prix sont indiqués en euros, toutes taxes comprises (TTC)</li>
          <li>Les prix peuvent varier en fonction des promotions ou des restaurants</li>
          <li>LEMO se réserve le droit de modifier les prix à tout moment, sans préavis</li>
          <li>Le prix applicable est celui affiché au moment de la validation de la commande</li>
        </ul>

        <h3>4.2 - Moyens de paiement</h3>
        <p>Les paiements sont effectués exclusivement en ligne via la plateforme sécurisée Stripe :</p>
        <ul>
          <li>Cartes bancaires (Visa, Mastercard, American Express)</li>
          <li>Apple Pay / Google Pay (selon disponibilité)</li>
        </ul>

        <h3>4.3 - Sécurité des paiements</h3>
        <ul>
          <li>Les transactions sont sécurisées via le protocole SSL/TLS</li>
          <li>LEMO ne stocke pas les données bancaires des clients</li>
          <li>Les données de paiement sont traitées directement par Stripe, certifié PCI-DSS</li>
        </ul>

        <h3>4.4 - Facturation</h3>
        <ul>
          <li>Une facture électronique est générée automatiquement après chaque commande</li>
          <li>La facture est disponible dans l'espace "Mon compte" du client</li>
          <li>Elle peut être téléchargée au format PDF</li>
        </ul>
      </section>

      <section id="article-5">
        <h2>Article 5 - Retrait de Commande (Click & Collect)</h2>
        
        <h3>5.1 - Lieu de retrait</h3>
        <ul>
          <li>Les commandes sont à retirer directement au restaurant partenaire</li>
          <li>L'adresse exacte du restaurant est indiquée dans la confirmation de commande</li>
          <li>Un itinéraire peut être affiché via Google Maps dans l'application</li>
        </ul>

        <h3>5.2 - Heure de retrait</h3>
        <ul>
          <li>Le client choisit un créneau horaire de retrait lors de la commande</li>
          <li>Le temps de préparation estimé est indiqué par le restaurant</li>
          <li>Le client reçoit une notification lorsque sa commande est prête</li>
        </ul>

        <h3>5.3 - Procédure de retrait</h3>
        <ul>
          <li>Le client doit présenter son numéro de commande (affiché dans l'application) au restaurant</li>
          <li>Le restaurant vérifie l'identité du client avant remise de la commande</li>
          <li>La commande est considérée comme livrée une fois remise au client</li>
        </ul>

        <h3>5.4 - Retard de retrait</h3>
        <ul>
          <li>En cas de retard supérieur à <strong>30 minutes</strong> après l'heure de retrait prévue, la commande peut être annulée par le restaurant</li>
          <li>Aucun remboursement ne sera effectué en cas de non-retrait imputable au client</li>
          <li>En cas de circonstances exceptionnelles, le client peut contacter le service client</li>
        </ul>
      </section>

      <section id="article-6">
        <h2>Article 6 - Annulation et Remboursement</h2>
        
        <h3>6.1 - Annulation par le client</h3>
        <ul>
          <li>Le client peut annuler sa commande dans les <strong>5 minutes</strong> suivant la validation</li>
          <li>Au-delà de ce délai, l'annulation n'est plus possible</li>
          <li>En cas d'annulation dans le délai imparti, le remboursement est effectué sous 5 à 10 jours ouvrables</li>
        </ul>

        <h3>6.2 - Annulation par le restaurant</h3>
        <ul>
          <li>Le restaurant peut annuler une commande en cas de rupture de stock ou de fermeture exceptionnelle</li>
          <li>Le client est informé par notification et email</li>
          <li>Un remboursement intégral est effectué automatiquement</li>
        </ul>

        <h3>6.3 - Remboursement</h3>
        <ul>
          <li>Les remboursements sont effectués via le même moyen de paiement utilisé lors de la commande</li>
          <li>Le délai de remboursement est de <strong>5 à 10 jours ouvrables</strong> selon les banques</li>
          <li>LEMO n'est pas responsable des délais de traitement bancaire</li>
        </ul>

        <h3>6.4 - Réclamations qualité</h3>
        <ul>
          <li>Toute réclamation concernant la qualité des produits doit être signalée dans les <strong>24 heures</strong> suivant le retrait</li>
          <li>Le client doit fournir des preuves (photos, description détaillée)</li>
          <li>LEMO arbitre les litiges entre clients et restaurants</li>
          <li>En cas de litige avéré, un remboursement partiel ou total peut être accordé</li>
        </ul>
      </section>

      <section id="article-7">
        <h2>Article 7 - Responsabilité</h2>
        
        <h3>7.1 - Responsabilité de LEMO</h3>
        <p>LEMO agit en tant qu'intermédiaire technique. LEMO n'est pas responsable de :</p>
        <ul>
          <li>La qualité, la conformité ou la sécurité sanitaire des produits (responsabilité du restaurant)</li>
          <li>Les erreurs de préparation ou les retards de service</li>
          <li>Les dommages survenant après le retrait de la commande</li>
        </ul>

        <h3>7.2 - Responsabilité du restaurant</h3>
        <ul>
          <li>Le restaurant est responsable de la qualité et de la conformité des produits vendus</li>
          <li>Le restaurant garantit le respect des normes d'hygiène et de sécurité alimentaire</li>
          <li>Le restaurant s'engage à respecter les délais de préparation annoncés</li>
        </ul>

        <h3>7.3 - Responsabilité du client</h3>
        <ul>
          <li>Le client est responsable de la vérification de sa commande avant le retrait</li>
          <li>Le client est responsable de la conservation des produits après retrait</li>
          <li>Le client doit signaler toute allergie ou intolérance alimentaire au restaurant</li>
        </ul>
      </section>

      <section id="article-8">
        <h2>Article 8 - Protection des Données Personnelles</h2>
        <p>
          Les données personnelles collectées dans le cadre des commandes sont traitées conformément 
          à notre <strong>Politique de Confidentialité</strong> et au Règlement Général sur la Protection 
          des Données (RGPD).
        </p>
        <ul>
          <li>Les données collectées sont : nom, prénom, email, téléphone, adresse de facturation</li>
          <li>Ces données sont utilisées uniquement pour le traitement des commandes et la communication avec le client</li>
          <li>Le client dispose d'un droit d'accès, de rectification et de suppression de ses données</li>
        </ul>
      </section>

      <section id="article-9">
        <h2>Article 9 - Service Client</h2>
        
        <h3>9.1 - Contact</h3>
        <p>Pour toute question ou réclamation :</p>
        <ul>
          <li><strong>Email</strong> : m.duclos@petites-natures.fr</li>
          <li><strong>Téléphone</strong> : 0689283990</li>
          <li><strong>Application</strong> : Menu "Aide" → "Contacter le support"</li>
        </ul>

        <h3>9.2 - Délais de réponse</h3>
        <ul>
          <li>Les demandes sont traitées dans un délai de <strong>24 à 48 heures</strong> ouvrables</li>
          <li>Les réclamations urgentes (commande en cours) sont prioritaires</li>
        </ul>

        <h3>9.3 - Médiation</h3>
        <p>
          En cas de litige non résolu, le client peut recourir à un médiateur de la consommation. 
          Les coordonnées du médiateur seront communiquées sur demande.
        </p>
      </section>

      <section id="article-10">
        <h2>Article 10 - Dispositions Générales</h2>
        
        <h3>10.1 - Droit applicable</h3>
        <p>
          Les présentes CGV sont soumises au droit français. Tout litige relève de la compétence 
          des tribunaux français.
        </p>

        <h3>10.2 - Modification des CGV</h3>
        <p>
          LEMO se réserve le droit de modifier les présentes CGV à tout moment. 
          Les modifications sont applicables à compter de leur publication sur la plateforme.
        </p>

        <h3>10.3 - Nullité partielle</h3>
        <p>
          Si une clause des présentes CGV est déclarée nulle, les autres clauses restent applicables.
        </p>

        <h3>10.4 - Intégralité</h3>
        <p>
          Les présentes CGV constituent l'intégralité de l'accord entre les parties concernant 
          la vente de produits via la plateforme LEMO.
        </p>
      </section>
    </LegalPageLayout>
  );
}
